"use strict";
exports.__esModule = true;
exports.DEFAULT_CONTENT = exports.DEFAULT_WIDTH = exports.DEFAULT_PLACEMENT = exports.DEFAULT_DISPLAY = void 0;
var tslib_1 = require("tslib");
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importStar(require("../../../theme/styled-components"));
var Citation_1 = tslib_1.__importDefault(require("./Citation"));
var HighlightedBox_1 = tslib_1.__importDefault(require("./HighlightedBox"));
exports.DEFAULT_DISPLAY = 'highlightedBox';
exports.DEFAULT_PLACEMENT = 'standard';
exports.DEFAULT_WIDTH = '100%';
exports.DEFAULT_CONTENT = '<p><br></p>';
var BasePositioner = function (_a) {
    var placement = _a.placement, width = _a.width, rest = tslib_1.__rest(_a, ["placement", "width"]);
    return (react_1["default"].createElement("div", tslib_1.__assign({}, rest)));
};
var Positioner = styled_components_1["default"](BasePositioner)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  float: none;\n  margin: 0;\n  width: 100%;\n  margin: 0 auto ", " auto;\n\n  ", " {\n    width: ", ";\n    ", "\n  }\n"], ["\n  float: none;\n  margin: 0;\n  width: 100%;\n  margin: 0 auto ", " auto;\n\n  ", " {\n    width: ", ";\n    ",
    "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.em(theme.grid.gutterWidth * 2.5);
}, utilities_1.mb('s'), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var placement = _a.placement, width = _a.width;
    return width !== '100%' &&
        (placement === 'right'
            ? styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n            float: right;\n            padding: 0 0 ", " ", ";\n            margin: 0;\n            position: relative;\n            z-index: 1;\n          "], ["\n            float: right;\n            padding: 0 0 ", " ", ";\n            margin: 0;\n            position: relative;\n            z-index: 1;\n          "])), polished_1.em(26), polished_1.em(26)) : placement === 'left'
            ? styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n            float: left;\n            padding: 0 ", " ", " 0;\n            margin: 0;\n            position: relative;\n            z-index: 1;\n          "], ["\n            float: left;\n            padding: 0 ", " ", " 0;\n            margin: 0;\n            position: relative;\n            z-index: 1;\n          "])), polished_1.em(26), polished_1.em(26)) : '');
});
var TextBlock = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, renderEmpty = _a.renderEmpty;
    var display = data.display || exports.DEFAULT_DISPLAY;
    var placement = data.placement || exports.DEFAULT_PLACEMENT;
    var width = data.width || exports.DEFAULT_WIDTH;
    var content = data.content || exports.DEFAULT_CONTENT;
    // needed to display editor widget overlay correctly
    var floatReset = !!renderEmpty && placement !== 'standard' && (react_1["default"].createElement("div", { style: { clear: 'both' } }));
    switch (display) {
        case 'highlightedBox':
            return (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(Positioner, { placement: placement, width: width, className: "content-widget-textBlock" },
                    react_1["default"].createElement(HighlightedBox_1["default"], { content: content, header: data.header || '', footer: data.footer || '', textColor: data.textColor || '', backgroundColor: data.backgroundColor || '', backgroundImage: data.backgroundImage || null })),
                floatReset));
        case 'citation':
            return (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(Positioner, { placement: placement, width: width, className: "content-widget-textBlock" },
                    react_1["default"].createElement(Citation_1["default"], { content: content, header: data.header || '', footer: data.footer || '', textColor: data.textColor || '', backgroundColor: data.backgroundColor || '', backgroundImage: data.backgroundImage || null })),
                floatReset));
        default:
            return null;
    }
};
exports["default"] = TextBlock;
var templateObject_1, templateObject_2, templateObject_3;
